import React from 'react';
import { Space } from '@gr-monorepo/common/ui';
import Modal from '@gr-monorepo/common/ui/Modal';
import { ButtonStyle, TitlePlate } from './styled';

const MessageModal = ({
  handleClose,
  handleCopyClick,
  title,
  children,
}: {
  handleClose: () => void;
  handleCopyClick: () => void;
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <Modal onClose={handleClose}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '832px' }}>
        <TitlePlate style={{width: '560px'}}>{title}</TitlePlate>
        <Space size={16} axis="vertical" />
        <TitlePlate
          style={{
            fontWeight: 400,
            textAlign: 'left',
            display: 'grid',
            gap: '16px',
          }}
        >
          {children}
        </TitlePlate>
        <Space size={24} axis="vertical" />
        <ButtonStyle color={'purple'} onClick={handleCopyClick}>
          Скопировать
        </ButtonStyle>
      </div>
    </Modal>
  );
};

export default MessageModal;
